
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 792 792"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M216 432h360v36H216zM216 540h360v36H216zM216 108h216v36H216zM216 648h360v36H216zM216 324h360v36H216z"}}),_c('path',{attrs:{"d":"M666.54 792S684 792 684 774.396V158.4L526.896 0H125.46S108 0 108 17.604V774.36C108 792 125.46 792 125.46 792h541.08zM144 36h360v108c0 36 36 36 36 36h108v576H144V36z"}}),_c('path',{attrs:{"d":"M216 216h360v36H216z"}})])
          )
        }
      }
    